<template>
  <v-container
    fluid
    fill-height
    class="pa-0 ma-0"
    justify-end
    align-center
    v-if="selected !== null"
    @keyup.left="toPrevious(index)"
    @keyup.right="toNext(index)"
  >
    <v-snackbar v-model="errorPrompt" color="critical" top right vertical :timeout="timeout">
      <p class="errorText pa-0 ma-0">{{ errorText }}</p>
      <v-btn color="white" flat @click="errorPrompt = false">close</v-btn>
    </v-snackbar>
    <v-layout>
      <EventCard
        :mobileWidth="mobileWidth"
        :mobileState="mobileState"
        :attachments="attachments"
        :displayTweets="displayTweets"
        :displayLink="displayLink"
        :style="eventCardStyles"
        v-show="generalGetEnableComponents"
      />
    </v-layout>
    <v-flex class="controls" justify-center align-center v-if="!mobileState">
      <v-card tile color="accent" class="controlCard" v-show="generalGetAutoDisplay">
        <v-progress-linear v-model="autoPlayTimer" :indeterminate="inProgress" class="my-0" height="4" color="primary"></v-progress-linear>
        <v-list class="controlPlayer">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="controlTitle"> {{ eventRegionCode }} - {{ selected._source.eventImportance }} </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ selected._source.eventScope }} - {{ eventCategory }} -
                <v-icon class="mr-1" small>mdi-chart-line</v-icon>
                <span class="subheading mr-2" v-if="selected._source.meter !== null">{{ selected._source.meter }}</span>
                <span class="subheading mr-2" v-if="selected._source.meter == null">0</span> <span class="mr-1">-</span>
                <v-icon class="mr-1" small>mdi-google-nearby</v-icon>
                <span class="subheading" v-if="selected._source.magnitude !== null">{{ selected._source.magnitude }}</span>
                <span class="subheading" v-if="selected._source.magnitude == null">0</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-spacer></v-spacer>
            <v-list-tile-action class="mr-4" @click="toPrevious(index)">
              <v-btn icon>
                <v-icon color="primary">mdi-chevron-left</v-icon>
                <div class="controlTitle">Previous</div>
              </v-btn>
            </v-list-tile-action>

            <v-list-tile-action :class="{ 'ml-5': $vuetify.breakpoint.mdAndUp }" @click="toSlowDown()" v-if="false">
              <v-btn icon> <v-icon color="primary">mdi-chevron-double-left</v-icon> </v-btn>
            </v-list-tile-action>

            <v-list-tile-action :class="{ 'mx-5': $vuetify.breakpoint.mdAndUp }" @click="autoPlay(internalIndex)" v-if="false">
              <v-btn icon>
                <v-icon color="primary" v-if="playPause">mdi-pause</v-icon>
                <v-icon color="primary" v-if="!playPause">mdi-play</v-icon>
              </v-btn>
            </v-list-tile-action>

            <v-list-tile-action :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }" @click="toSpeedUp()" v-if="false">
              <v-btn icon> <v-icon color="primary">mdi-chevron-double-right</v-icon> </v-btn>
            </v-list-tile-action>

            <v-list-tile-action class="ml-4" :class="{ 'mx-3': $vuetify.breakpoint.mdAndUp }" @click="toNext(index)">
              <v-btn icon>
                <div class="controlTitle">Next</div>
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
    <NewEvents class="newEvents" v-show="newEventsBuffer" :newEvents="newEvents" :dateNow="getDate" @updateInternalIndex="internalIndex = $event" />
    <template>
      <Loader v-if="showLoader" />
      <v-container id="mapid" fluid class="map pa-0"></v-container>
    </template>
  </v-container>
</template>

<script>
/* eslint-disable */
import EventCard from '@/components/EventCard';
import Loader from '@/components/Loader';
import NewEvents from '@/components/NewEvents';
import { mapGetters } from 'vuex';

export default {
  name: 'LandingPage',
  components: {
    EventCard,
    NewEvents,
    Loader
  },
  data() {
    return {
      earth: null,
      errorPrompt: false,
      eventCircle: false,
      userPolygon: false,
      circle: null,
      polygon: null,
      marker: null,
      flyToDuration: 2.5,
      flyToZoom: 0.25,
      playPause: false,
      inProgress: false,
      timeout: 3000,
      autoPlayTimer: 100,
      zoomLevel: 10,
      errorText: 'You reach the End of the List',
      interval: null,
      internalIndex: 0,
      showLoader: true
    };
  },
  computed: {
    ...mapGetters({
      selected: 'selected',
      events: 'events',
      index: 'index',
      newEventsBuffer: 'newEventsBuffer',
      newEvents: 'newEvents',
      getDate: 'getDate',
      mobileState: 'generalGetMobileState',
      mobileWidth: 'generalGetWidthState',
      dataGetLocation: 'dataGetLocation',
      generalGetCountryZoom: 'generalGetCountryZoom',
      generalGetEnableComponents: 'generalGetEnableComponents',
      generalGetAutoDisplay: 'generalGetAutoDisplay'
    }),
    attachments() {
      return this.selected._source.attachments.filter(a => {
        if (a.deleted && a.hasOwnProperty('deleted')) {
          return;
        } else {
          return ['photo', 'video'].includes(a.type);
        }
      });
    },
    displayTweets() {
      return this.selected._source.tweets.filter(t => {
        if (t.deleted && t.hasOwnProperty('deleted')) {
          return;
        } else {
          const Description = t.status.text.length > 90 ? t.status.text.slice(0, 90) + '...' : t.status.text;
          Object.assign(t, { Description });
          return t;
        }
      });
    },
    displayLink() {
      return this.selected._source.attachments.filter(t => {
        if(t.type === 'url') {
          if(t.deleted && t.hasOwnProperty('deleted')) {
            return;
          } else {
            let Description;
            if (this.mobileState) {
              Description = t.url.length > 40 ? t.url.slice(0, 40) + '...' : t.url;
            } else {
              Description = t.url.length > 70 ? t.url.slice(0, 70) + '...' : t.url;
            }
            // const Description = t.url.length > 40 ? t.url.slice(0, 40) + '...' : t.url;
            Object.assign(t, { Description });
            return t;
          }
        }
      });
    },
    eventRegionCode() {
      if (this.selected._source.eventRegionCode === 'NA') {
        return 'North America Region';
      } else if (this.selected._source.eventRegionCode === 'AN') {
        return 'Antartica Region';
      } else if (this.selected._source.eventRegionCode === 'AS') {
        return 'Asia Region';
      } else if (this.selected._source.eventRegionCode === 'EU') {
        return 'Europe Region';
      } else if (this.selected._source.eventRegionCode === 'SA') {
        return 'South America Region';
      } else if (this.selected._source.eventRegionCode === 'AF') {
        return 'Africa Region';
      } else if (this.selected._source.eventRegionCode === 'OC') {
        return 'Oceanic Region';
      } else {
        return this.selected._source.eventLocationName;
      }
    },
    eventCategory() {
      if (this.selected._source.eventCategory === 'Plc') {
        return 'Police';
      } else if (this.selected._source.eventCategory === 'Hlt') {
        return 'Health';
      } else {
        return 'Natural Disaster';
      }
    },
    eventCardStyles() {
      if (!this.mobileState) {
        return 'position: absolute; z-index: 1; margin-left: 5rem; margin-top: 1rem;'
      } else {
        return `position: absolute; z-index: 1; width: ${this.mobileWidth}`
      }
    }
  },
  watch: {
    selected(newSelected, oldSelected) {
      if (oldSelected !== null) {
        if (newSelected._id !== oldSelected._id) {
          if (oldSelected !== null) {
            this.removeLayers();
          }
          if (this.earth !== null) {
            this.panTo(newSelected);
          }
        }
      }
    },
    generalGetCountryZoom(newValue) {
      if(newValue) {
        if(this.earth.getZoom() !== 4) {
          this.inProgress = true;
          setTimeout(() => {
            this.earth.setZoom(4, {
              animate: true
            });
            this.inProgress = false;
          }, 1000);
        }
      }
    }
  },
  async mounted() {
    setTimeout(() => {
      this.showLoader = false;
    }, 5500);
    await window.setTimeout(() => {
      this.initializeMap();
      this.panTo(this.selected);
      this.internalIndex = this.index;
      this.initializePoints();
    }, 3000);
  },
  methods: {
    initializeMap() {
      this.earth = L.map('mapid', {
        center: [43.65, -79.38],
        zoom: this.zoomLevel,
        setMaxZoom: 20,
        setMinZoom: 5
      });
      const esriStreets = L.esri.Vector.basemap('Newspaper').addTo(this.earth);
      esriStreets;
    },
    initializePoints() {
      if (this.dataGetLocation.length == 0) {
        window.setTimeout(() => {
          this.initializePoints();
        }, 1000);
      } else {
        this.marker = this.dataGetLocation.map(i => {
          let markers = L.marker([i[0], i[1]]).addTo(this.earth);
          let places;
          if (i[2].provinceState.length == 0) {
            places = i[2].countryRegion;
          } else {
            places = i[2].countryRegion + ' - ' + i[2].provinceState;
          }
          markers.bindPopup(`<div><strong>${places}</strong></div><div>Confirmed: ${i[2].confirmed}</div><div>Deaths: ${i[2].deaths}</div><div>Recovered: ${i[2].recovered}</div>`)
          return markers;
        });
      }
    },
    removeLayers() {
      this.circle.removeFrom(this.earth);
      // if (this.marker.length != 0) {
      //   this.polygon.removeFrom(this.earth);
      //   this.marker.forEach(markers => {
      //     markers.removeFrom(this.earth);
      //   });
      // }
      this.eventCircle = false;
      this.userPolygon = false;
    },
    displayEventMarkers(array) {
      // console.log([array[0], array[1]]);
      // let offset = this.mobileState == false ? [array[0] - 0.2, array[1] + 0.3] : [array[0], array[1]];
      // console.log(offset);
      this.circle = L.circle([array[0] - 0.2, array[1] + 0.3], {
        color: '#EF8E24',
        fillColor: '#FFA94B',
        fillOpacity: 0.5,
        radius: 4000
      }).addTo(this.earth);
      this.eventCircle = true;
    },
    displayUserMarkers(array) {
      this.polygon = L.polygon(array).addTo(this.earth);
      //add custom marker using leaflet.js
      this.marker = array.map(i => {
        let markers = L.marker([i[0], i[1]]).addTo(this.earth);
        return markers;
      });
      this.userPolygon = true;
    },
    getUserLocation(selected) {
      let userLocations = selected._source.userLocation;
      if (typeof userLocations === 'undefined') return null;
      if (userLocations.length === 0) return null;
      let userArrayLocation = [];
      for (var i = 0; i < userLocations.length; i++) {
        let location = userLocations[i]
          .split(',')
          .map(c => parseFloat(c))
          .map(c => (isNaN(c) ? 0 : c));
        userArrayLocation.push(location);
      }
      return userArrayLocation;
    },
    getEventLocation(selected) {
      let locations = selected._source.eventLocation;
      if (typeof locations === 'undefined') return null;
      if (locations === undefined) return null;
      let location = locations
        .split(',')
        .map(c => parseFloat(c))
        .map(c => (isNaN(c) ? 0 : c));
      //add centerize offsets
      if(!this.mobileState) {
        location[0] += 0.2;
        location[1] -= 0.3;
      }
      return location;
    },
    panTo(selected) {
      this.inProgress = true;
      let locationArray = this.getEventLocation(selected);
      let userArray = this.getUserLocation(selected);
      this.displayEventMarkers(locationArray);
      // if (userArray !== null) {
      //   this.displayUserMarkers(userArray);
      // }
      this.earth.panTo(locationArray,{
        animate: true,
        duration: this.flyToDuration,
        easeLinearity: this.flyToDuration
      });
      if(this.earth.getZoom() !== 10) {
        setTimeout(() => {
          this.earth.setZoom(10, {
            animate: true
          });
          this.inProgress = false;
        }, 3000);
      } else {
        this.inProgress = false;
      }
    },
    toNext(index) {
      if (this.index == this.events.length - 1) {
        this.errorText = 'End of the list';
        this.errorPrompt = !this.errorPrompt;
        if (this.playPause) {
          this.autoPlay(index);
        }
      } else {
        if (!this.inProgress) {
          if (index >= this.index) {
            index = this.index;
            this.$store.dispatch('select', ++index);
            this.internalIndex = index;
          }
        }
      }
    },
    autoPlay(internalIndex) {
      this.playPause = !this.playPause;
      if (this.playPause) {
        this.interval = setInterval(() => {
          this.toNext(++internalIndex);
        }, 1000);
      } else {
        clearInterval(this.interval);
      }
    },
    toPrevious(index) {
      if (this.index == 0) {
        this.errorText = 'End of the list';
        this.errorPrompt = !this.errorPrompt;
      } else {
        this.$store.dispatch('select', --index);
        this.internalIndex = index;
      }
    },
    toSlowDown() {
      if (this.flyToDuration >= 5.5 && this.flyToZoom <= 7500) {
        this.errorText = '🐌 Scarlet Snail-ster? 🐌';
        this.errorPrompt = !this.errorPrompt;
      } else {
        this.flyToDuration = this.flyToDuration + 0.25;
        this.flyToZoom = this.flyToZoom + 250;
      }
    },
    toSpeedUp() {
      if (this.flyToDuration <= 1.5 && this.flyToZoom <= 2500) {
        this.errorText = '🏃🏻‍ Scarlet Speedster 🏃🏻';
        this.errorPrompt = !this.errorPrompt;
      } else {
        this.flyToDuration = this.flyToDuration - 0.25;
        this.flyToZoom = this.flyToZoom - 250;
      }
    }
  }
};
</script>

<style scoped>
#mapid {
  height: 100%;
  width: 100%;
  background-color: #d8d8d8;
}
.map {
  z-index: 0;
}
.errorText {
  font-size: 1.1rem;
  font-weight: bold;
}
.newEvents {
  position: absolute;
  z-index: 300;
  top: 2rem;
  right: 3rem;
}
.eventCards {
  position: absolute;
  margin-left: 5rem;
  margin-top: 1rem;
  z-index: 1;
}
.controlPlayer {
  background-color: #eaeef7;
}
.controlTitle {
  color: #085280;
}
.controls {
  position: absolute;
  z-index: 1;
  left: 5rem;
  right: 5rem;
  bottom: 1.5rem;
}
.prompt {
  font-size: 1.5rem;
}
</style>
